var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_138_2934",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.818359,
    y: 0.488281,
    width: 50.5814,
    height: 50.5814,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_138_2934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4763 42.6393H34.7425V36.3167C34.7425 33.9172 33.9035 31.865 32.2256 30.16C30.5476 28.455 28.5089 27.6024 26.1094 27.6024C23.71 27.6024 21.6713 28.455 19.9933 30.16C18.3153 31.865 17.4763 33.9172 17.4763 36.3167V42.6393ZM26.1094 23.9553C28.5089 23.9553 30.5476 23.1028 32.2256 21.3978C33.9035 19.6928 34.7425 17.6405 34.7425 15.2411V8.91842H17.4763V15.2411C17.4763 17.6405 18.3153 19.6928 19.9933 21.3978C21.6713 23.1028 23.71 23.9553 26.1094 23.9553ZM10.3027 45.8007V42.6393H14.3155V36.3167C14.3155 33.9443 14.9647 31.7847 16.2629 29.838C17.5612 27.891 19.2816 26.538 21.4243 25.7789C19.2816 25.0061 17.5612 23.6497 16.2629 21.7097C14.9647 19.7697 14.3155 17.6135 14.3155 15.2411V8.91842H10.3027V5.75708H41.9161V8.91842H37.9033V15.2411C37.9033 17.6135 37.2542 19.7697 35.9559 21.7097C34.6577 23.6497 32.9372 25.0061 30.7945 25.7789C32.9372 26.538 34.6577 27.891 35.9559 29.838C37.2542 31.7847 37.9033 33.9443 37.9033 36.3167V42.6393H41.9161V45.8007H10.3027Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.81c1bb0266231ad69e1cb7dd9c94df73.svg";
export { ForwardRef as ReactComponent };